import React from 'react'

export const AlertBox: React.FC<{
  message: string
  retryHandler: () => void
}> = ({ message, retryHandler }) => (
  <div data-bind='visible: isError' className='modalSection m1em text-center'>
    <span className='alertBox__icon alertBox__icon--confirm' />
    <div className='pb5 pt10 fz-16 faux-strong' />
    <div className='alertBox__text' data-tid-alertboxmessage=''>
      <div className='dib phalfem'>{message}</div>
      <div className='dib'>Please try again later.</div>
    </div>

    <div className='l-faux-table l-table-fixed w100'>
      <div className='l-faux-row'>
        <div className='l-faux-cell p1em'>
          <button
            type='button'
            className='button modalSection__button flat ls0 w100 fz-14 greenwhite'
            onClick={retryHandler}
          >
            Try again
          </button>
        </div>
      </div>
    </div>
  </div>
)
